<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text dropdown">
                        <h1>Trinka para Microsoft Word
                            <span>Apenas com Premium</span>
                        </h1>
                        <p>O plug-in Trinka para Word torna a escrita eficaz mais fácil do que nunca! A Trinka verifica automaticamente
                            sua escrita e alterações à medida que você escreve dentro do aplicativo Word que você já conhece.</p>
                        <div id="MacMSWordButton">
                            <button title="Word plugin coming soon for Mac OS">
                                <img src="../../../assets/images/safari_logo.png" alt="safari logo"> Em breve
                            </button>
                            <span>
                                <a href="https://s3.amazonaws.com/trinka-word-plugin/64bit/Trinka.Installer.msi" target="_blank">* Baixe o Add-in para Windows aqui.</a>
                            </span>
                        </div>
                        <div class="wordPluginCTA" id="MSWindowDownloadButton">
                            <b id="windowInfo64bit"></b>
                            <i class="">Beta</i>
                        </div>
                        <span id="MSWindowTextContent">*Suporta Word 2010 para cima e apenas no Windows.</span>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/MSWordBanner.png" alt="ms word">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="advanceGrammerSpellCheck_section publishEnhancements_slider accomplishSections">
        <div class="container">
            <div class="row">
                <div class="col-xl-6">
                    <div class="accomplishSections_img">

                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="../../../assets/images/microsoft-wordThumbnails.jpg" alt="microsoft thumbnail" class="img-fluid eposter-img">
                            
                        </a>
                    </div>
                </div>

                <div class="col-xl-6">
                    <div class="spellcheck_heading EnhancementsHeadingSection">
                        <h2>Comece a usar o Trinka Add-in para Word no Windows</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Precisa de ajuda para instalar ou quer saber como fazer correções usando o add-in?</p>
                        <p>Confira o vídeo passo a passo fácil para começar imediatamente.</p>
                        <p>Tem mais perguntas? Navegue por nossas perguntas frequentes
                            <a (click)="scroll(target)" class="link">aqui</a>.</p>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>Principais recursos do Plug-in do Trinka Microsoft Word</h2>
                        <div class="HeadingSubLine"></div>
                        <p>A Trinka está disponível como um plug-in para o aplicativo MS Word que você já conhece e sempre usou.
                            Receba correções e sugestões enquanto escreve, com Trinka verificando automaticamente todas as
                            suas alterações para que você não perca nada!</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="style guide">
                        <h3>Preferências do Guia de Estilo</h3>
                        <p>Personalize a gramática e a escolha da palavra do seu manuscrito para cumprir os guias de estilo
                            acadêmico populares (AMA 11th, AGU 2017).</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="subject area">
                        <h3>Área de Assunto e Tipo de Documento</h3>
                        <p>Personalize o Trinka para fornecer as sugestões mais relevantes com base na sua área de assunto e
                            no tipo de manuscrito.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="add to dictionay">
                        <h3>Adicionar ao dicionário</h3>
                        <p>Adicione suas próprias palavras ao “Meu Dicionário” e Trinka não as sinalizará como erros ortográficos
                            em sua escrita futura.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt="data security">
                        <h3>Segurança de dados</h3>
                        <p>O que quer que você digita é transmitido e analisado com segurança. Seus dados nunca são salvos conosco.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="features_cards commingSoonTag">
                        <img src="../../../assets/images/sendForHumanEditing.svg" alt="human editing">
                        <h3>Enviar para Edição Humana</h3>
                        <p>Precisa de um especialista humano para editar seu manuscrito final? Envie-o para os editores especialistas
                            do Enago diretamente do editor Trinka.</p>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="pricingQuestionAnwser" #target>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="pricingHeadingQuestion">
                        <h2>FAQs</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
                <div class="col-lg-10">
                    <div class="pricingQuestionsList">
                        <div class="accordion" id="faq">
                            <div class="card">
                                <div class="card-header" id="QuestionOne">
                                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                        Como adiciono / instalo o Trinka para Microsoft Word?</a>
                                </div>

                                <div id="QuestionOneContent" class="collapse show" aria-labelledby="QuestionOne" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Na página do suplemento Trinka para MS Word você pode encontrar o botão "Baixar agora".
                                            Depois de baixar o arquivo de instalação, clique nele para iniciar o processo
                                            de instalação. Após a instalação bem-sucedida, abra o aplicativo MS Word. Na
                                            faixa superior, você encontrará uma nova guia chamada Trinka. Clique na guia
                                            e clique em "Login" para fazer o login com sua conta premium e começar a usar
                                            o Trinka.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header" id="QuestionTwo">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                        aria-controls="QuestionTwoContent">Como eu ativo a verificação de gramática do Trinka no Word?</a>
                                </div>

                                <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Depois de baixar e instalar o suplemento Trinka para MS Word, você só precisa fazer
                                            o login usando as credenciais de sua conta Trinka e clicar no botão "Iniciar"
                                            na guia Trinka no menu da faixa de opções.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionThree">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                        aria-controls="QuestionThreeContent">
                                        Quais são os requisitos do sistema para instalar o Trinka no Microsoft Word?
                                    </a>
                                </div>

                                <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Trinka para MS Word funciona no Microsoft Word 2010 e superior no Windows. O add-in
                                            para MS Word no Mac estará disponível em breve.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFour">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                        aria-controls="QuestionFourContent">
                                        Posso usar o Trinka Word Add-in no Mac?
                                    </a>
                                </div>

                                <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                    <div class="card-body">
                                        <p>O add-in para MS Word no Mac está em desenvolvimento e estará disponível em breve.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionFive">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                        aria-controls="QuestionFiveContent">
                                        O suplemento do MS Word da Trinka verifica a ortografia e a gramática em tempo real?
                                    </a>
                                </div>

                                <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Sim, o suplemento MS Word da Trinka verifica e sugere correções em tempo real. Além
                                            disso, ele detecta todas as alterações que você faz e verifica novamente a sua
                                            escrita para correções instantaneamente.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSix">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                        aria-controls="QuestionSixContent">
                                        Como aceito ou rejeito uma sugestão?
                                    </a>
                                </div>

                                <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Aceitar ou rejeitar uma sugestão é muito fácil. Basta clicar na palavra sugerida
                                            para aceitar / aplicar a correção ou clicar no ícone 'Polegar para baixo' para
                                            rejeitá-la.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionSeven">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                        aria-controls="QuestionSevenContent">
                                        Posso alternar entre o inglês dos EUA e do Reino Unido no suplemento do Word da Trinka?
                                    </a>
                                </div>

                                <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                    <div class="card-body">
                                        <p>sim. Você pode alternar entre Inglês dos EUA e Inglês do Reino Unido na opção de
                                            menu Configurações e Verificação de Idioma no menu da faixa de opções.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEightSection">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                        aria-controls="QuestionEightSectionContent">
                                        Posso selecionar entre os guias de estilo no Trinka Word Add-in?
                                    </a>
                                </div>

                                <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                    <div class="card-body">
                                        <p>sim. Você pode selecionar o guia de estilo preferido na opção de menu Configurações
                                            e verificação de idioma no menu da faixa de opções.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionEight">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                        aria-controls="QuestionEightContent">
                                        Como utilizo o Trinka se não tenho MS Word e escrevo online (Google Docs, Medium, etc.)?
                                    </a>
                                </div>

                                <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Você pode usar nossos plug-ins de navegador para os navegadores Chrome, Firefox e
                                            Edge para usar o Trinka em seus sites favoritos. Clique aqui para fazer o download
                                            do
                                            <a href="/browser-plugin">Trinka Browser Plug-in</a>.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="QuestionTen">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                        aria-controls="QuestionTenContent">
                                        O que devo fazer se não conseguir encontrar o Suplemento do Word da Trinka após a instalação bem-sucedida?
                                    </a>
                                </div>

                                <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                    <div class="card-body">
                                        <p>Em alguns casos, a segurança do sistema / organização pode desabilitar a ativação
                                            do add-in. Você pode tentar habilitá-lo manualmente em Arquivo -> Opções -> Suplementos
                                            -> Gerenciar -> Adicionar COM.
                                            <a href="https://youtu.be/RDrzQOBNAsk" target="_blank">Assista a este vídeo</a> para uma explicação detalhada.</p>
                                    </div>
                                </div>
                            </div>

                            <div class="card">
                                <div class="card-header" id="Question11">
                                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                        aria-controls="Question11Content">
                                        O que devo fazer se o Suplemento Trinka Word não conseguir detectar erros?
                                    </a>
                                </div>

                                <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                    <div class="card-body">
                                        <p style="margin-bottom: 30px;">
                                            Isso pode ser devido a vários problemas.
                                        </p>
                                        <ul>
                                            <li>Verifique sua conexão com a Internet. Você precisa estar conectado à internet
                                                para que o Trinka detecte erros e sugira correções.</li>
                                            <li>Verifique se o add-in não está desabilitado devido às configurações de segurança
                                                do seu sistema / organização.</li>
                                            <li>Tente desinstalar e reinstalar o suplemento.</li>
                                            <li>Se o problema ainda persistir, envie um e-mail para
                                                <a href="mailto:support@trinka.ai">support@trinka.ai</a> e nossa equipe o ajudará a resolvê-lo.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>

    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>Use o Trinka em outros aplicativos</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <div class="app_name_content" routerLink="/trinkacloud">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                        <h3>Trinka Cloud</h3>

                                    </div>
                                </li>
                                <!-- <li>
                                    <div class="app_name_content" routerLink="/wordplugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                        <h3>MS Word Plug-in</h3>

                                    </div>
                                </li> -->
                                <li>
                                    <div class="app_name_content" routerLink="/browser-plugin">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/other_Apps_browser.svg" alt="bowser plugin">
                                        <h3>Plugins do navegador</h3>

                                    </div>
                                </li>
                                <li>
                                    <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                        <h3 style="margin: 0 0 -2px 0;">Empresas</h3>
                                        <span style="font-size: 11px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                    </div>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/cTo16u94rxc"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>